import { useEffect } from "react";

import { COST_TYPES } from "Signups/SharedComponents/costTypes";
import { useSignups } from "Signups/state";

/**
 Signup pricing is actually stored at the item level.
 So we derive the "Signup level" values by looking at the signup items.
 */
export function useSetInitialPricingValues() {
  const [{ currentSignupList }, dispatch] = useSignups();
  const signupCostType = currentSignupList?.fundIt?.cost?.costType;
  // const items = currentSignupList?.signupItems;
  const amounts = currentSignupList?.fundIt?.cost?.amounts;

  useEffect(() => {
    // if (!(Array.isArray(items) && items.length > 0)) {
    //   return;
    // }

    // let hasCosts = false;
    let isPerSignupCostType = true;

    if (signupCostType === COST_TYPES.PER_SIGNUP) {
      isPerSignupCostType = true;
    } else {
      isPerSignupCostType = false;
    }

    dispatch({
      type: "setSignupListIsPerSignupCostType",
      payload: isPerSignupCostType,
    });

    if (!isPerSignupCostType) {
      return;
    }

    dispatch({
      type: "setSignupListPerSignupCostTypeAmounts",
      payload: amounts,
    });
  }, [amounts, dispatch, signupCostType]);
}
